export default __webpack_public_path__ + "static/media/easy-connectivity.eafc3951.png";